import { Box, Typography } from "@mui/material";
import queryString from "query-string";
import { useEffect, useState } from "react";
import {getFinalSalaryData, getOpenHoursData, getPCData, getPerformanceData} from "../../../services/staff-services/bonusService";
import {pageSizeOptions, pageSize, page} from "../../../utils/paginationConfig";
import { CustomTableRenderer } from "../../../utils/dataGridCustom";
import Loader from "../../global/Loader";
import { useDispatch } from "react-redux";
import { SetCurrentPageTopic } from "../../../store/action/headerChange";
import { saveAs } from "file-saver";
import { escapeCSVField } from "../../../utils/utils";
import { toast } from "react-toastify";

const SalaryDetails = () => {
  const [openHoursBonusData, setOpenHoursBonusData] = useState([]);
  const [paginationModel1, setPaginationModel1] = useState({page: page, pageSize: pageSize});
  const [rowCount1, setRowCount1] = useState(0);
  const [isLoading1, setIsLoading1] = useState(true);

  const [performanceBonusData, setPerformanceBonusData] = useState([]);
  const [paginationModel2, setPaginationModel2] = useState({page: page, pageSize: pageSize});
  const [rowCount2, setRowCount2] = useState(0);
  const [isLoading2, setIsLoading2] = useState(true);

  const [pcBonusData, setPcBonusData] = useState([]);
  const [paginationModel3, setPaginationModel3] = useState({page: page, pageSize: pageSize});
  const [rowCount3, setRowCount3] = useState(0);
  const [isLoading3, setIsLoading3] = useState(true);

  const [finalData, setFinalData] = useState([]);
  const [paginationModel4, setPaginationModel4] = useState({page: page, pageSize: pageSize});
  const [rowCount4, setRowCount4] = useState(0);
  const [isLoading4, setIsLoading4] = useState(true);
  
  const [isLoading, setIsLoading] = useState(true);
  const [salaryId, setSalaryId] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const headerData1 = ["Center Name", "Hours Avg", "Grading", "Amount"];
  const headerData2 = ["Center Name", "Percentage", "Grading", "Amount"];
  const headerData3 = ["Center Name", "Total PCs", "PC count above 21", "Total amount"];
  const headerData4 = ["Center Name", "Basic", "Phone Allowance", "Hourly Average", "Hourly Additional Payment", "Performance Average", "Performance Additional Payment", "Total Computer Count", "Additional Computers", "Computer Additional Payment Amount", "Total Additional Payment", "Final Monthly Payment"];

  const dispatch = useDispatch();
  dispatch(SetCurrentPageTopic(`${from} TO ${to} DETAILS`));

  const openHoursBonusTableColumns = [
    {
      field: "centerName",
      headerName: headerData1[0],
      flex: 4,
      renderCell: (params) => (
        <Box style={{ textTransform: "uppercase" }}>{params.value}</Box>
      ),
    },
    {
      field: "hoursAvg",
      headerName: headerData1[1],
      flex: 3,
    },
    {
      field: "grading",
      headerName: headerData1[2],
      flex: 3,
    },
    {
      field: "bonus",
      headerName: headerData1[3],
      flex: 3,
    },
  ];

  const performanceBonusTableColumns = [
    {
      field: "centerName",
      headerName: headerData2[0],
      flex: 4,
      renderCell: (params) => (
        <Box style={{ textTransform: "uppercase" }}>{params.value}</Box>
      ),
    },
    {
      field: "pcPerformance",
      headerName: headerData2[1],
      flex: 3,
    },
    {
      field: "grading",
      headerName: headerData2[2],
      flex: 3,
    },
    {
      field: "bonus",
      headerName: headerData2[3],
      flex: 3,
    },
  ];

  const pcBonusTableColumns = [
    {
      field: "centerName",
      headerName: headerData3[0],
      flex: 4,
      renderCell: (params) => (
        <Box style={{ textTransform: "uppercase" }}>{params.value}</Box>
      ),
    },
    {
      field: "totalPcCount",
      headerName: headerData3[1],
      flex: 3,
    },
    {
      field: "pcCountAbove21",
      headerName: headerData3[2],
      flex: 3,
    },
    {
      field: "bonus",
      headerName: headerData3[3],
      flex: 3,
    },
  ];
  const finalColumns = [
    {
      field: "centerName",
      headerName: headerData4[0],
      flex: 4,
      renderCell: (params) => (
        <Box style={{ textTransform: "uppercase" }}>{params.value}</Box>
      ),
    },
    {
      field: "basicSalary",
      headerName: headerData4[1],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "phoneAllowance",
      headerName: headerData4[2],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "hourlyAverage",
      headerName: headerData4[3],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "hourlyBonus",
      headerName: headerData4[4],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "pcsPerformance",
      headerName: headerData4[5],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "performanceBonus",
      headerName: headerData4[6],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "totalPcsCount",
      headerName: headerData4[7],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "additionalPcsCount",
      headerName: headerData4[8],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "additionalPcsBonusAmount",
      headerName: headerData4[9],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "totalBonus",
      headerName: headerData4[10],
      flex: 3,
      cellClassName: "name-column--cell",
    },
    {
      field: "finalSalary",
      headerName: headerData4[11],
      flex: 3,
      cellClassName: "name-column--cell",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const parsed = queryString.parse(window.location.search);
      setSalaryId(parsed.id);
      setFrom(parsed.from);
      setTo(parsed.to);

      await handleGetOpenHoursData(parsed.id, page, pageSize);
      await handleGetPerformanceData(parsed.id, page, pageSize);
      await handleGetPCData(parsed.id, page, pageSize);
      await handleGetFinalSalaryData(parsed.id, page, pageSize);

      setIsLoading(false);
    };
    fetchData();
  }, []);


    const handleGetOpenHoursData = async (id, page, limit) => {
      setIsLoading1(true);
      try {
        const obj = { page, limit };
        const response = await getOpenHoursData(id, obj);

        setOpenHoursBonusData(response.data.data);
        setRowCount1(response.data.totalCount ?? 0);
        setPaginationModel1({ page, pageSize: limit });
      } catch (error) {
        console.log(error);
        // toast.error("Please refresh");
      }
      setIsLoading1(false);
    };

    const handlePaginationModelChange1 = (newModel) => {
      const resetPage = newModel.pageSize !== paginationModel1.pageSize;
      const updatedModel = {
        ...newModel,
        page: resetPage ? 0 : newModel.page,
      };

      handleGetOpenHoursData(salaryId,updatedModel.page,updatedModel.pageSize);
    };

    const handleExportCSVOpenHoursData = async () => {
      try {
        const response = await getOpenHoursData(salaryId, {page: 0, limit: rowCount1});

        const data = response.data.data;
        const csvRows = data.map((row) =>
          [
            escapeCSVField(row.centerName),
            escapeCSVField(row.hoursAvg),
            escapeCSVField(row.grading),
            escapeCSVField(row.bonus),
          ].join(",")
        );

        const csvContent = [headerData1.join(","), ...csvRows].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, `hourly_allowance_rate_data.csv`);
      } catch (error) {
        console.error("CSV Export Failed:", error);
        toast.error("Failed to export CSV.");
      }
    };

    const handleGetPerformanceData = async (id, page, limit) => {
      setIsLoading2(true);
      try {
        const obj = { page, limit };
        const response = await getPerformanceData(id, obj);

        setPerformanceBonusData(response.data.data);
        setRowCount2(response.data.totalCount ?? 0);
        setPaginationModel2({ page, pageSize: limit });
      } catch (error) {
        console.log(error);
        // toast.error("Please refresh");
      }
      setIsLoading2(false);
    };

    const handlePaginationModelChange2 = (newModel) => {
      const resetPage = newModel.pageSize !== paginationModel2.pageSize;
      const updatedModel = {
        ...newModel,
        page: resetPage ? 0 : newModel.page,
      };

      handleGetPerformanceData(salaryId,updatedModel.page,updatedModel.pageSize);
    };

    const handleExportCSVPerformanceData = async () => {
      try {
        const response = await getPerformanceData(salaryId, {page: 0, limit: rowCount2});

        const data = response.data.data;
        const csvRows = data.map((row) =>
          [
            escapeCSVField(row.centerName),
            escapeCSVField(row.pcPerformance),
            escapeCSVField(row.grading),
            escapeCSVField(row.bonus),
          ].join(",")
        );

        const csvContent = [headerData2.join(","), ...csvRows].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, `performance_based_allowance_data.csv`);
      } catch (error) {
        console.error("CSV Export Failed:", error);
        toast.error("Failed to export CSV.");
      }
    };

    const handleGetPCData = async (id, page, limit) => {
      setIsLoading3(true);
      try {
        const obj = { page, limit };
        const response = await getPCData(id, obj);

        setPcBonusData(response.data.data);
        setRowCount3(response.data.totalCount ?? 0);
        setPaginationModel3({ page, pageSize: limit });
      } catch (error) {
        console.log(error);
        // toast.error("Please refresh");
      }
      setIsLoading3(false);
    };

    const handlePaginationModelChange3 = (newModel) => {
      const resetPage = newModel.pageSize !== paginationModel3.pageSize;
      const updatedModel = {
        ...newModel,
        page: resetPage ? 0 : newModel.page,
      };

      handleGetPCData(salaryId,updatedModel.page,updatedModel.pageSize);
    };

    const handleExportCSVPCData = async () => {
      try {
        const response = await getPerformanceData(salaryId, {page: 0, limit: rowCount3});

        const data = response.data.data;
        const csvRows = data.map((row) =>
          [
            escapeCSVField(row.centerName),
            escapeCSVField(row.totalPcCount),
            escapeCSVField(row.pcCountAbove21),
            escapeCSVField(row.bonus),
          ].join(",")
        );

        const csvContent = [headerData3.join(","), ...csvRows].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, `pc_based_allowance_data.csv`);
      } catch (error) {
        console.error("CSV Export Failed:", error);
        toast.error("Failed to export CSV.");
      }
    };

    const handleGetFinalSalaryData = async (id, page, limit) => {
      setIsLoading4(true);
      try {
        const obj = { page, limit };
        const response = await getFinalSalaryData(id, obj);

        setFinalData(response.data.data);
        setRowCount4(response.data.totalCount ?? 0);
        setPaginationModel4({ page, pageSize: limit });
      } catch (error) {
        console.log(error);
        // toast.error("Please refresh");
      }
      setIsLoading4(false);
    };

    const handlePaginationModelChange4 = (newModel) => {
      const resetPage = newModel.pageSize !== paginationModel4.pageSize;
      const updatedModel = {
        ...newModel,
        page: resetPage ? 0 : newModel.page,
      };

      handleGetFinalSalaryData(salaryId,updatedModel.page,updatedModel.pageSize);
    };

    const handleExportCSVFinalSalaryData = async () => {
      try {
        const response = await getFinalSalaryData(salaryId, {page: 0, limit: rowCount4});

        const data = response.data.data;
        const csvRows = data.map((row) =>
          [
            escapeCSVField(row.centerName),
            escapeCSVField(row.basicSalary),
            escapeCSVField(row.phoneAllowance),
            escapeCSVField(row.hourlyAverage),
            escapeCSVField(row.hourlyBonus),
            escapeCSVField(row.pcsPerformance),
            escapeCSVField(row.performanceBonus),
            escapeCSVField(row.totalPcsCount),
            escapeCSVField(row.additionalPcsCount),
            escapeCSVField(row.additionalPcsBonusAmount),
            escapeCSVField(row.totalBonus),
            escapeCSVField(row.finalSalary),
          ].join(",")
        );

        const csvContent = [headerData4.join(","), ...csvRows].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, `total_compensation_and_bonus_summary.csv`);
      } catch (error) {
        console.error("CSV Export Failed:", error);
        toast.error("Failed to export CSV.");
      }
    };

  if (isLoading) {
    return <Loader />;
  }
  
  return (
    <Box m="0 20px">
      <Typography variant="h2" sx={{ textAlign: "center", padding: "20px" }}>
        HOURLY ALLOWANCE RATE TABLE
      </Typography>
      <CustomTableRenderer
        columns={openHoursBonusTableColumns}
        data={openHoursBonusData}
        id="centerCode"
        paginationMode="server"
        rowCount={rowCount1}
        pageSizeOptions={pageSizeOptions}
        paginationModel={paginationModel1}
        onPaginationModelChange={handlePaginationModelChange1}
        handleExportCSV={handleExportCSVOpenHoursData}
        loading={isLoading1}
      />

      <Typography variant="h2" sx={{ textAlign: "center", padding: "20px" }}>
        PERFORMANCE BASED ALLOWANCE TABLE
      </Typography>
      <CustomTableRenderer
        columns={performanceBonusTableColumns}
        data={performanceBonusData}
        id="centerCode"
        paginationMode="server"
        rowCount={rowCount2}
        pageSizeOptions={pageSizeOptions}
        paginationModel={paginationModel2}
        onPaginationModelChange={handlePaginationModelChange2}
        handleExportCSV={handleExportCSVPerformanceData}
        loading={isLoading2}
      />

      <Typography variant="h2" sx={{ textAlign: "center", padding: "20px" }}>
        PC BASED ALLOWANCE TABLE
      </Typography>
      <CustomTableRenderer
        columns={pcBonusTableColumns}
        data={pcBonusData}
        id="centerCode"
        paginationMode="server"
        rowCount={rowCount3}
        pageSizeOptions={pageSizeOptions}
        paginationModel={paginationModel3}
        onPaginationModelChange={handlePaginationModelChange3}
        handleExportCSV={handleExportCSVPCData}
        loading={isLoading3}
      />

      <Typography variant="h2" sx={{ textAlign: "center", padding: "20px" }}>
        TOTAL COMPENSATION AND BONUS SUMMARY
      </Typography>
      <CustomTableRenderer
        columns={finalColumns}
        data={finalData}
        id="centerCode"
        paginationMode="server"
        rowCount={rowCount4}
        pageSizeOptions={pageSizeOptions}
        paginationModel={paginationModel4}
        onPaginationModelChange={handlePaginationModelChange4}
        handleExportCSV={handleExportCSVFinalSalaryData}
        loading={isLoading4}
      />
    </Box>
  );
};

export default SalaryDetails;
